import React, { Component, useState, useEffect } from 'react';
import {connect} from 'react-redux';

import { Typography, Grid, Box, Container } from '@material-ui/core';

import TitleText from './components/TitleText';
import KontenText from './components/KontenText';
import Garis from './components/Garis';
import RenderChart from './components/RenderChart';

import Footer from './components/Footer';
import GrafikBarTegak from './components/GrafikBarTegak'
import './styleDinas.css';
import jsonDummy from './cekData.json';
import KontenTextImage from './components/KontenTextImage';
import GarisSegitigaMandiri from './components/GarisSegitigaMandiri';

class DinasJatim_5_6 extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    componentDidMount(){
    }
    

    render() { 

        return (
            <Grid 
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="stretch"
                spacing={2}>

                <Grid item>
                    <KontenTextImage logo={'/image/dinas/header-static.png'} title={'rata-rata nilai per cabdindik'} subTitle={'Provinsi Jawa Timur'}/>
                </Grid>

                <Grid item xs={12} align="center">
                    <div className="header-table main-bg-color">
                        <table width="100%">
                             <thead>
                                <tr style={{textAlign: '-webkit-center'}}>
                                    <th colSpan="2">
                                        <KontenTextImage logo={null} title={'rata-rata nilai cabang dinas di jawa timur'} subTitle={null}/>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    jsonDummy.list.map((val, i)=>
                                        <tr style={{height: 40}}>
                                            <td width="250px" className="custom">
                                                {val.nama}
                                                <hr style={{border: 'solid #BDBDBD 1px', width: '100%', marginBottom: 0,marginTop: '6px'}} />
                                            </td>
                                            <td  className="custom">
                                                {/* <div className="w3-progress-container w3-round-xlarge text-center" >
                                                    <div className="w3-progressbar w3-round-xlarge" style={{width: Number(val.rataMapel).toFixed(2)+"%", "backgroundColor": "#FFDB15"}}>
                                                        <span style={{padding: '0 10px',fontSize: '14px'}}>{val.rataMapel}%</span>
                                                    </div>
                                                </div> */}
                                                <div className="w3-progress-container w3-round-xlarge text-center" >
                                                    <div className="w3-progressbar w3-round-xlarge" style={{width: "50%", "backgroundColor": "#EBA83A"}}>
                                                        <span style={{padding: '2px 10px',fontSize: '14px', float: 'right'}}>50%</span>
                                                    </div>
                                                </div>
                                                <GarisSegitigaMandiri />
                                            </td>
                                        </tr>
                                    )
                                }

                                
                            </tbody>
                        </table>
                    </div>
                </Grid>


                {/* tabel rata-rata nilai cabang dinas */}

                <Grid item xs={12} align="center">
                    <div className="header-table main-bg-color">
                        <table width="100%" className="table-striped">
                             <thead>
                                <tr style={{textAlign: '-webkit-center'}}>
                                    <th rowSpan="2">kantor cabang dinas</th>
                                    <th colSpan="5">tabel rata-rata nilai cabang dinas <Garis /></th>
                                </tr>
                                <tr style={{textAlign: '-webkit-center'}}>
                                    <th>matematika</th>
                                    <th>bhs. indonesia</th>
                                    <th>bhs.inggris</th>
                                    <th>pen.umum</th>
                                    <th>rata-rata</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    jsonDummy.list.map((val, i)=>
                                        <tr>
                                            <td style={{background: i%2 == 0 ? '#FFFFFF' : '#1E3163 / 30%'}}>{val.nama}</td>
                                            <td className="text-center" style={{background: i%2 == 0 ? '#FFFFFF' : '#1E3163 / 30%'}}>0</td>
                                            <td className="text-center" style={{background: i%2 == 0 ? '#FFFFFF' : '#1E3163 / 30%'}}>0</td>
                                            <td className="text-center" style={{background: i%2 == 0 ? '#FFFFFF' : '#1E3163 / 30%'}}>0</td>
                                            <td className="text-center" style={{background: i%2 == 0 ? '#FFFFFF' : '#1E3163 / 30%'}}>0</td>
                                            <td className="text-center" style={{background: i%2 == 0 ? '#FFFFFF' : '#1E3163 / 30%'}}>0</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </Grid>
                
                
            </Grid>

        );
    }
}

export default DinasJatim_5_6;